import { Button, Icon } from "@sicredi/react";
import styles from "./styles.module.scss";

interface IButtonLinkChevronRight {
  sizeIcon?: SizeIcon;
  text: string;
  onClick?: () => void;
  marginTop?: number;
}
enum SizeIcon {
  size8 = 8,
  size16 = 16,
  size24 = 24,
  size32 = 32,
  size40 = 40,
  size56 = 56,
  size64 = 64,
  size72 = 72,
  size104 = 104,
}

export const ButtonLinkChevronRight: React.FC<IButtonLinkChevronRight> = ({
  sizeIcon,
  text,
  onClick,
  marginTop = 16,
}) => {
  return (
    <div className={styles.container} style={{ marginTop: marginTop }}>
      <Button
        onClick={onClick}
        appearance="link"
        className={styles.button_link}
      >
        {text}
        <Icon
          name="chevron-right"
          size={!sizeIcon ? 16 : sizeIcon}
          className={styles.icon}
        />
      </Button>
    </div>
  );
};
